import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-45eb3176"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "universe-container" };
const _hoisted_2 = {
    key: 0,
    class: "absolute noselect top-left umbra padding-inline-small padding-block-mini border-round margin-top-left-mini"
};
const _hoisted_3 = { class: "top-right flex-column absolute" };
const _hoisted_4 = { class: "bottom-right flex-column absolute" };
const _hoisted_5 = _withScopeId(() => _createElementVNode("hr", { class: "margin-small shadow" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoadingIndicator = _resolveComponent("LoadingIndicator");
    const _component_StateSvg = _resolveComponent("StateSvg");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("canvas", {
            class: "universe-canvas",
            onClick: _cache[0] || (_cache[0] =
                (...args) => (_ctx.onClickCanvas && _ctx.onClickCanvas(...args)))
        }),
        _createVNode(_Transition, { name: "universe-loading" }, {
            default: _withCtx(() => [
                (_ctx.isServerFlightsLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_LoadingIndicator)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_StateSvg, {
                src: "svg/xray.svg",
                class: "universe-action-icon shadow",
                onClick: _ctx.onClickXRay
            }, null, 8, ["onClick"]),
            _createVNode(_component_StateSvg, {
                src: "svg/map.svg",
                class: "universe-action-icon shadow",
                onClick: _ctx.onClickMap
            }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_StateSvg, {
                src: "svg/zoom_in.svg",
                class: "universe-action-icon shadow",
                onClick: _ctx.onClickZoomIn
            }, null, 8, ["onClick"]),
            _hoisted_5,
            _createVNode(_component_StateSvg, {
                src: "svg/zoom_out.svg",
                class: "universe-action-icon shadow",
                onClick: _ctx.onClickZoomOut
            }, null, 8, ["onClick"])
        ])
    ]));
}
